import { SubmitHandler, useForm } from 'react-hook-form';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import PrimaryInput from '../ui/PrimaryInput';
import { IDeleteResponse, INotificationForm } from '@/interfaces/common.model';
import { errorTypes } from '@/utility/validation';
import ToggleInput from '../ui/ToggleInput';
import MultiSelectSearch from '../ui/MultiSelectSearch';
import Label from '../ui/Label';
import FieldLayout from '../Layout/FieldLayout';
import { useEffect, useState } from 'react';
import FormButtons from '../common/Form/FormButtons';
import { showToastNotification } from '@/utility/helper';
import ErrorMessage from '../common/ErrorMessage';
import { IEmployeeOnBoardResponse } from '@/interfaces/employee.model';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
interface ISendNotificationModalProps {
  closeHandler: () => void;
  isOpen: boolean;
}
export interface IUserList {
  label: string;
  value: string;
}
const SendNotificationModal = ({
  closeHandler,
  isOpen,
}: ISendNotificationModalProps) => {
  const [selectedUser, setSelectedUser] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [userList, setUserList] = useState<IUserList[] | null>(null);
  const {
    register,
    watch,
    setValue,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<INotificationForm>();
  useEffect(() => {
    getEmployeeList();
  }, []);
  useEffect(() => {
    register('userIds', { ...errorTypes.required('Users') });
  }, [register]);
  useEffect(() => {
    if (isOpen) {
      reset({
        title: '',
        message: '',
        isForAll: true,
        userIds: [],
      });
      setSelectedUser([]);
    }
  }, [isOpen, reset]);
  const handleUserSelect = (selected: string[]) => {
    setValue('userIds', selected);
    setSelectedUser(selected);
  };
  const onSubmit: SubmitHandler<INotificationForm> = async (data) => {
    if (!data?.isForAll && data?.userIds && selectedUser?.length == 0) {
      return showToastNotification('danger', 'Please select atleast 1 user');
    }
    const submitData = {
      title: data?.title,
      ...(data?.isForAll
        ? { isForAll: data?.isForAll }
        : { userIds: selectedUser }),
      message: data?.message,
    };
    try {
      setIsLoading(true);
      const response: IDeleteResponse = await callApi(
        API_URL + API_ENDPOINT.createNotification,
        {
          method: 'POST',
          data: submitData,
        },
      );
      if (response?.status) {
        closeHandler();
        reset();
        showToastNotification('success', response?.message);
      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };
  const getEmployeeList = async () => {
    // const filter = {

    //   pageSize: filterDetails?.pageSize,
    //   pageNumber: filterDetails.currentPage,
    // };
    try {
      const response: IEmployeeOnBoardResponse = await callApi(
        API_URL + API_ENDPOINT.getEmployee,
        // + '?' + getFilterUrl(filter),
        { method: 'GET' },
      );
      if (response?.status) {
        const newData = response?.data?.user?.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
        setUserList(newData);
      }
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };
  return (
    <Modal
      className=""
      isOpen={isOpen}
      toggle={closeHandler}
      size="md"
      scrollable={true}
      centered
    >
      <ModalHeader toggle={closeHandler}>
        <h3>Send Notification</h3>
      </ModalHeader>
      <form onSubmit={handleSubmit(onSubmit)}>
        <ModalBody
          className="p-4"
          style={{ maxHeight: '80vh', overflowY: 'auto' }}
        >
          <div className="modal-content">
            <div className="row">
              <div className="col-12">
                <div className="form-group mb-3">
                  <PrimaryInput
                    label="Title"
                    required={true}
                    errors={errors?.title?.message}
                    placeholder="Enter title"
                    {...register('title', { ...errorTypes.required('Title') })}
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group mb-3">
                  <PrimaryInput
                    placeholder="Enter message"
                    label="Message"
                    errors={errors?.message?.message}
                    required={true}
                    {...register('message', {
                      ...errorTypes.required('Message'),
                    })}
                  />
                </div>
                <div className="d-flex gap-3">
                  <ToggleInput
                    id="canAccessTeamYes"
                    label="Alert To All"
                    {...register('isForAll')}
                    className={`form-check-input rounded-4`}
                  />
                </div>
                {!watch('isForAll') && userList && (
                  <FieldLayout fieldStyle="w-100">
                    <Label id={'users'} required={true}>
                      Select User
                    </Label>
                    <MultiSelectSearch
                      isSelectAll={false}
                      selectedOption={selectedUser}
                      placeholder={'select user'}
                      options={userList}
                      handleChange={handleUserSelect}
                    />
                    <ErrorMessage message={errors?.userIds?.message} />
                  </FieldLayout>
                )}
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <FormButtons toggleModal={closeHandler} isLoading={isLoading}>
            Send notification
          </FormButtons>
        </ModalFooter>
      </form>
    </Modal>
  );
};
export default SendNotificationModal;
